<template>
  <v-flex class="agent-invite-clients">
    <v-card id="agentInviteClients">
      <v-card-title class="card-title">
        Invite
      </v-card-title>
      <v-divider />
      <v-card-title class="card-title">
        Invite a Client
      </v-card-title>
      <div class="button-container">
        <v-btn
          class="button-invite-client"
          :color="colors.hwayzBrandBlue"
          @click="showInviteClient = true"
        >
          Invite a client
        </v-btn>
      </div>
      <v-divider />
      <v-card-title class="card-title">
        Invite Multiple Client
      </v-card-title>
      <file-uploader v-model="csvFile" filetype=".csv" class="button-container" @input="showCSV()">
        <template v-slot:activator>
          <v-btn :color="colors.hwayzBrandBlue" class="button-uploader">
            Upload CSV
          </v-btn>
        </template>
      </file-uploader>
    </v-card>
    <v-dialog
      v-model="showInviteClient"
      persistent
      :width="modal.width"
      :max-width="modal.maxWidth"
    >
      <invite-buyer-form @on-modal-close="showInviteClient=false" />
    </v-dialog>
    <confirm-modal
      :show="showResultModal"
      :text="resultMessage"
      @click-button="showResultModal = false"
      @close-modal="showResultModal = false"
    />
    <invite-clients-modal
      :show="showModal"
      :button-text="buttonText"
      @close-modal="closeModal"
      @click-button="sendClientData(clients)"
    >
      <updated-list-component
        :table-headers="clientsDataHeaders"
        :table-data="generateClientData(parsedDataWithNewType)"
        :custom-headers="false"
      />
    </invite-clients-modal>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex'
import FileUploader from '../../components/uiUtils/FileUploader'
import UpdatedListComponent from '../../components/uiUtils/UpdatedListComponent'
import InviteClientsModal from '../../components/modals/InviteClientsModal'
import InviteBuyerForm from '../../components/agent/invite/InviteBuyerForm.vue'
import ConfirmModal from '../../components/modals/ConfirmModal'
import { inviteClients } from '../../services/invite-service'
import colors from '../../scss/_colors.scss'
import PapaParse from 'papaparse'

export default {
  components: {
    FileUploader,
    UpdatedListComponent,
    InviteClientsModal,
    InviteBuyerForm,
    ConfirmModal
  },
  data() {
    return {
      csvFile: null,
      colors,
      parsedData: [],
      clientsDataHeaders: [
        {
          text: 'Name',
          value: 'name',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Email',
          value: 'email',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Phone',
          value: 'phone',
          sortable: false,
          align: 'center'
        }
      ],
      buttonText: 'Save',
      showModal: false,
      parsedDataWithNewType: [],
      clients: {},
      errors: [],
      showInviteClient: false,
      showResultModal: false,
      resultMessage: ''
    }
  },

  computed: {
    ...mapState('style', ['modal'])
  },

  methods: {
    showCSV() {
      PapaParse.parse(this.csvFile.newFile, {
        skipEmptyLines: true,
        complete: results => {
          this.parsedData = results.data
          this.openModal()
          this.convertDataForTable(this.parsedData)
        }
      })
    },

    generateClientData(tableDataArray) {
      let responseData = []
      tableDataArray.forEach((item, index) => {
        let rowObject = {}
        rowObject[0] = {
          type: 'text',
          class: 'text-xs-center',
          text: item.name,
          data: { value: item }
        }
        rowObject[1] = {
          type: 'text',
          class: 'text-xs-center lowercase',
          text: item.email,
          data: { value: item }
        }
        rowObject[2] = {
          type: 'text',
          class: 'text-xs-center',
          text: item.phone,
          data: { value: item }
        }
        if (
          this.errors.length !== 0 &&
          this.errors[index].email === item.email
        ) {
          rowObject[3] = {
            type: 'text',
            class: 'text-xs-center request-error',
            text: this.errors[index].message,
            data: { value: this.errors[index] }
          }
        }
        responseData.push(rowObject)
      })
      return responseData
    },

    openModal() {
      this.showModal = true
    },

    async sendClientData(data) {
      this.errors = []
      const response = await inviteClients(data)

      if (response.status !== 207) {
        this.showModal = false
        this.resultMessage = 'Invalid data'
        this.showResultModal = true
        return
      }

      response.data.forEach((item, index) => {
        if (item.message !== undefined) {
          this.errors.push({
            email: item.email,
            message: item.message
          })
        }
      })

      if (this.errors.length !== 0) {
        const isErrorColumnShown = this.clientsDataHeaders.find(
          item => item.value === 'error'
        )
        if (!isErrorColumnShown) {
          return this.clientsDataHeaders.push({
            text: 'Error',
            value: 'error',
            sortable: false,
            align: 'center'
          })
        }
        return
      }

      this.showModal = false
      this.resultMessage = 'User(s) were created successfully.'
      this.showResultModal = true
    },

    convertDataForTable(data) {
      data.shift() // if in parsed data always exist array with keys
      this.parsedDataWithNewType = []
      data.forEach(clientData => {
        this.parsedDataWithNewType.push({
          name: clientData[0],
          email: clientData[1],
          phone: clientData[2]
        })
      })
      this.clients.accounts = this.parsedDataWithNewType
      return this.parsedDataWithNewType
    },

    closeModal() {
      this.showModal = false
    }
  }
}
</script>

<style lang="sass">
.agent-invite-clients
  // max-height: 300px
  display: flex
#agentInviteClients
  width: 100%
  height: 100%
  flex: 1 auto
.button-container
  display: flex
  justify-content: center
  margin: 0
  padding: 16px 0
.request-error
  color: red !important
.lowercase
  text-transform: none
.button-invite-client
  width: 200px !important
.button-uploader
  width: 200px !important
.button-invite-client, .button-uploader
  border-radius: 5px
.button-invite-client .v-btn__content, .button-uploader .v-btn__content
  color: white !important
  font-weight: 500 !important
.button-uploader:hover, .button-invite-client:hover
  background-color: $hwayzBrandGold !important
</style>
